import { styled } from '@mui/styles';

export const ButtonsContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    height: '45px',
    '& .button': {
        marginRight: '10px',
        border: `0.8px solid ${theme.palette.graphics.stroke} `,
        borderRadius: '8px',
        backgroundColor: theme.palette.colors.white,
        color: theme.palette.darkGrey,
        height: '100%',
        padding: '13px 17px',
        boxShadow: '0px 2px 6px rgba(112, 144, 176, 0.07)',
        '&:hover': {
            boxShadow: '0px 2px 7px rgba(112, 144, 176, 0.14)',
        },
        '&:hover .MuiSvgIcon-root': {
            color: theme.palette.colors.bluePale,
        },
        '&:hover.no-blue-icon .MuiSvgIcon-root': {
            color: theme.palette.darkGrey,
        },
    },
    '& .disabled': {
        backgroundColor: theme.palette.colors.greyInformationLight,
    },
    '& .move-prospects-button': {
        width: '128px',
        '&:hover .MuiSvgIcon-root': {
            color: theme.palette.colors.bluePale,
        },
        whiteSpace: 'nowrap',
    },
    '& .admin-button': {
        color: theme.palette.darkGrey,
        '& svg': {
            fill: theme.palette.darkGrey,
        },
        // width: '400px',
        '&:hover svg': {
            fill: theme.palette.colors.bluePale,
        },
        whiteSpace: 'nowrap',
    },
}));

export const FiltersContainers = styled('div')(({ theme: { palette } }) => ({
    height: '40px',
    borderRadius: `8px`,
    '& .input': {
        width: '100%',
        minWidth: '340px',
        paddingLeft: '14px',
        boxSizing: 'border-box',
        border: `1px solid ${palette.colors.greyInformationLight}`,
        borderRadius: `8px`,
        backgroundColor: palette.colors.white,
        textAlign: 'left',
        color: palette.subline,
        fontSize: '14px',

        '& * > .MuiInputBase-input': {
            padding: '14px 16px 14px 0',
        },
        '& * > svg': {
            color: palette.colors.lightGrey,
        },
        '&.focused': {
            border: `1px solid ${palette.colors.bluePale}`,
            outline: `2px solid ${palette.colors.mediumBlue}`,
        },
    },
}));
